import { render, staticRenderFns } from "./InternationalChannel.vue?vue&type=template&id=f6310b8a&scoped=true"
import script from "./InternationalChannel.vue?vue&type=script&lang=js"
export * from "./InternationalChannel.vue?vue&type=script&lang=js"
import style0 from "./InternationalChannel.vue?vue&type=style&index=0&id=f6310b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6310b8a",
  null
  
)

export default component.exports